import UserFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => <GenericCreateForm formLayoutComponent={<UserFormLayout />} transformValues={transformValues} />
